import styled, { css } from 'styled-components';
import { getTransition, getFixedSpace, mq, px2rem } from '../../../stylesheets/tools';

const StyledHeader = styled.header`
  position: ${props => (props.accessibilityIsOpen ? 'fixed' : 'relative')};
  z-index: 98;
  width: 100%;
  top: 0;
  left: 0;

  .header__wrapper {
    pointer-events: none;
    padding: ${getFixedSpace('xxxs')};

    ${mq('s')} {
      padding: ${getFixedSpace('xs')};
    }
    ${mq('xl')} {
      padding: ${getFixedSpace('xs')} ${getFixedSpace('m')};
    }
  }
  .header__wrapper {
    gap: 20px;
    position: absolute;
    z-index: 98;
    color: #000;
    top: 0;
    left: 0;
    width: 100%;
    opacity: 1;
    ${getTransition('defaultFast')}
    transition: top 1s ease-out; // top, opacity are updated via JS archive timeline
    display: flex;
    flex-direction: row-reverse;
    align-items: center;

    ${mq('s')} {
      gap: 0px;
    }
    ${mq('m')} {
      flex-direction: row-reverse;
    }
    ${mq('xl')} {
      flex-wrap: nowrap;
    }

    [data-whatinput='keyboard'] &:focus-within,
    [data-whatinput='keyboard'] &:focus-within {
      transform: translateY(0);
    }

    ${props =>
      props.backgroundGradient &&
      !props.accessibilityIsOpen &&
      css`
        &:after {
          content: '';
          z-index: -1;
          top: 0;
          left: 0;
          width: 100%;
          position: absolute;
          height: 100%;
          background: linear-gradient(360deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
        }
      `}
    ${props =>
      props.accessibilityIsOpen &&
      css`
        position: fixed;
        transform: translateY(0);
        background: #000;
        color: #fff;

        .header__logo {
          opacity: 1;
          color: #fff;
        }
      `}
  }

  /* Filters */
  .header__filter {
    display: none;
    flex-grow: 0;

    ${mq('m')} {
      flex-grow: 2;
    }

    ${mq('xl')} {
      flex-grow: 0;
    }

    padding: 0;
  }

  .header-filter-box {
    display: flex;
    align-items: center;
    padding: 15px;

    ${mq('m')} {
      height: 75px;
      padding: 0 25px;
    }

    .header-filter-box-search,
    .header-filter-box-accessibility {
      display: none;

      ${mq('s')} {
        display: inline-block;
      }
    }
  }
  .header__logo-wrapper {
    position: relative;
    pointer-events: auto;

    ${mq('m')} {
      flex-shrink: 0;
    }
  }
  .header__logo {
    cursor: pointer;
    max-width: 240px;
    height: auto;

    ${props =>
      props.noLogo &&
      css`
        display: none;
        opacity: ${props.accessibilityIsOpen ? '1' : '0'};

        ${mq('l')} {
          display: block;
        }

        &:focus {
          opacity: 1;
          display: block;
        }
      `}
    svg {
      max-height: 30px;
      width: 100%;
      height: auto;
      fill: ${props => (props.inverted || props.invertedLogo ? '#fff' : '#000')};
    }

    ${mq('m')} {
      display: block;
      width: 260px;
      align-self: center;
    }

    ${mq('xl')} {
      width: auto;
    }
  }

  ${props =>
    props.inverted &&
    css`
      background: #000;
      color: #fff;
    `}
  .header__button-wrapper {
    position: relative;
    display: flex;
    width: 100%;
    flex: 1;

    ${mq('s')} {
      flex-shrink: 0;
      flex-grow: 2;
    }

    .header-filter-box {
      pointer-events: auto;
      display: inline-flex;
      width: auto;
    }
    ${mq('m')} {
      width: auto;
      display: inline-block;
    }

    button,
    .header__language-switch {
      margin-left: ${px2rem('18px')};

      ${mq('s')} {
        margin-left: ${getFixedSpace('s')};
      }
    }

    button:first-of-type {
      flex-grow: 2;
      display: flex;
      align-items: flex-start;
      margin-left: 0;

      ${mq('m')} {
        display: inline-block;
      }
    }
  }

  .headroom--unfixed {
    .header__wrapper {
      transform: translateY(0);
      color: #000;
      background: transparent;
    }
    // .header__logo-wrapper {
    //   display: none;
    // }
    .header__filter {
      display: none;
    }
  }

  .headroom--unpinned .header__wrapper {
    transform: translateY(-100%);
    background: #000;
    color: #fff;

    svg,
    g,
    path {
      fill: #fff;
    }

    .header__logo {
      opacity: 1;
    }
  }

  .headroom--pinned {
    .header__wrapper {
      color: #fff;
      transform: translateY(0);

      svg,
      g,
      path {
        fill: #fff;
      }

      .header__language-switch span {
        color: #fff;
      }
      .header-filter-box {
        position: relative;
        background: #000000b0;
        backdrop-filter: saturate(50%) hue-rotate(335deg) blur(6px) contrast(220%);
        border-radius: 8px;

        // &:before {
        //   opacity: 0.75;
        //   content: '';
        //   position: absolute;
        //   inset: 0;
        //   z-index: -1;
        // }
      }
      .header__logo-wrapper {
        display: none;

        ${mq('m')} {
          display: flex;
        }
      }
      .header__logo-wrapper {
        opacity: 1;
      }
    }

    .header__filter {
      display: block;
    }
  }

  @media print {
    .header__logo-wrapper {
      position: relative;
      top: 0;
      left: 0;
      right: auto;
    }

    .header__logo[href]:after {
      content: '';
    }

    .header__button-wrapper {
      display: none;
    }
  }
`;

export default StyledHeader;
